import styles from './index.module.css'
import { Notification } from '@appkit4/react-components/notification'
import classnames from 'classnames'

export const View = ({ className, ...props }) => {
    return (
        <Notification
            className={classnames(styles.default, className)}
            {...props}
            position="topHeader"
            closeable={false}
        />
    )
}
